import {
  VISUALITZACIO_INICIALITZAR,
  VISUALITZACIO_OMPLIR_DATA_FI
} from "../../actions/actionTypes";
import { dataActual, MASCARA_ISO_DIA, textAMoment } from "../../utils/dates";

const ESTAT_INICIAL = dataActual().format(MASCARA_ISO_DIA);

const dataFi = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case VISUALITZACIO_INICIALITZAR:
      return ESTAT_INICIAL;

    case VISUALITZACIO_OMPLIR_DATA_FI:
      return action.payload.format(MASCARA_ISO_DIA);

    default:
      return state;
  }
};

export default dataFi;

export const getDataFi = state => state.dataFi;

export const getDataFiAsMoment = state =>
  textAMoment(state.dataFi, MASCARA_ISO_DIA);
